export default "__VITE_ASSET__HgP46TTX__"